var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          key: _vm.curKey,
          staticStyle: { "min-width": "680px !important" },
          attrs: {
            width: _vm.deleteModel ? 300 : _vm.width,
            "hide-overlay": _vm.hideOverlay,
            "max-width": _vm.maxWidth,
            "no-click-animation": _vm.noClickAnimation,
            "overlay-opacity": _vm.overlayOpacity,
            "overlay-color": _vm.overlayColor,
            persistent: _vm.persistent,
            scrollable: _vm.scrollable,
          },
          on: {
            "click:outside": function ($event) {
              _vm.persistent ? null : _vm.closeDialog()
            },
          },
          scopedSlots: _vm._u(
            [
              _vm.isTriger
                ? {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _vm._t(
                          "activator",
                          function () {
                            return [_c("v-btn", _vm._g({}, on))]
                          },
                          { on: on, attrs: attrs }
                        ),
                      ]
                    },
                  }
                : null,
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-lg", attrs: { elevation: 3 } },
            [
              _vm.show_title
                ? _c(
                    "v-toolbar",
                    {
                      staticClass: "white--text",
                      attrs: {
                        color: _vm.color + " ",
                        flat: "",
                        dense: "",
                        height: "40",
                      },
                    },
                    [
                      _vm.deleteModel
                        ? _c(
                            "v-toolbar-title",
                            {
                              staticClass: "text-body-2",
                              class: _vm.headerClass,
                            },
                            [_vm._v("警告")]
                          )
                        : _c(
                            "v-toolbar-title",
                            {
                              staticClass: "text-body-2",
                              class: _vm.headerClass,
                            },
                            [_vm._v(" " + _vm._s(_vm.title) + " ")]
                          ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            color: _vm.closeBtnColor,
                            ripple: false,
                            height: "35",
                            "x-small": "",
                            width: "35",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.closeDialog.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "material-icons-round md-24" },
                            [_vm._v("close")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("subtitle"),
              _c(
                "v-card-text",
                { class: "pa-" + _vm.pad },
                [
                  _vm._t("content", function () {
                    return [
                      _vm.deleteModel
                        ? _c("v-sheet", [
                            _vm._v("是否删除" + _vm._s(_vm.title) + "?"),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              _vm._t("actions", function () {
                return [
                  _vm.deleteModel
                    ? _c("CardActions", {
                        attrs: { okBtn: "" },
                        on: {
                          cancel: function ($event) {
                            return _vm.onTriger("close")
                          },
                          ok: function ($event) {
                            return _vm.onTriger("confirm")
                          },
                        },
                      })
                    : _vm._e(),
                ]
              }),
              _vm._t("tools"),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }